
import HashtagDown from "../../../assets/duotone/HashtagDown.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function HashtagDownIcon({ className, dataTestid = "HashtagDownIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <HashtagDown data-testid={dataTestid} className={classes} {...rest} />
  );
}
